export const getCSRFToken = () => window.CSRF;
